// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1sh3D","rootCenter":"LoadMoreObserver_rootCenter___1VjC","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1EODc"};